export default __webpack_public_path__ + "static/media/PropertyDev_Shapes-01-1.4351b0e5.png";